export const couponToppingAll = '0'
export const couponNotTopping = '1'
export const couponToppingOnly = '2'

export const SESSION_COUPON = ['selectOption', 'priceDiscount', 'infoCoupon', 'goodCouponId', 'typeCoupon']